import React from 'react';
import '../styles/LogoSection.css';
import LogoImg from '../assets/logo.png';
import { Link } from 'react-router-dom';

const LogoSection = () => {
  return (
    <Link to="/">
      <img src={LogoImg} alt="풋소설 로고" />
    </Link>
  );
};

export default LogoSection;
